import React from "react";
import { formatCompact } from "../StatTile";
import "./AgingRankedList.css";

// Ranked by $ overdue, descending — surfaces who is holding the most money
// stuck in the pipeline rather than who simply has the most items.
const AgingRankedList = ({ rows, maxItems = 8 }) => {
  if (!rows || rows.length === 0) {
    return <div className="aging-ranked-empty">No approver data for the current filters.</div>;
  }

  const sorted = [...rows].sort((a, b) => b.totalAmount - a.totalAmount);
  const visible = sorted.slice(0, maxItems);
  const overflow = sorted.length - visible.length;

  return (
    <div className="aging-ranked-list">
      {visible.map((row, idx) => (
        <div key={row.key} className="aging-ranked-row">
          <span className="aging-ranked-rank">{idx + 1}</span>
          <span className="aging-ranked-name" title={row.label}>{row.label}</span>
          <span className="aging-ranked-count">{row.totalCount} item{row.totalCount === 1 ? "" : "s"}</span>
          <span className="aging-ranked-amount">{formatCompact(row.totalAmount, { currency: true })}</span>
          <span className="aging-ranked-dot" style={{ background: row.dominantColor }} title={row.dominantLabel} />
        </div>
      ))}
      {overflow > 0 && <div className="aging-ranked-overflow">+{overflow} more in the table below</div>}
    </div>
  );
};

export default AgingRankedList;
